/**
 * @generated SignedSource<<23d9c442b9ad137cb1f3a793e609cd08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EmailConfirmMutationInput = {
  clientMutationId?: string | null;
  code: string;
  token: string;
};
export type CampaignInputEmailConfirmSaveMutation$variables = {
  input: EmailConfirmMutationInput;
};
export type CampaignInputEmailConfirmSaveMutation$data = {
  readonly emailConfirm: {
    readonly __typename: "EmailConfirmError";
    readonly message: string;
  } | {
    readonly __typename: "Influencer";
    readonly email: string;
    readonly newEmail: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type CampaignInputEmailConfirmSaveMutation = {
  response: CampaignInputEmailConfirmSaveMutation$data;
  variables: CampaignInputEmailConfirmSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newEmail",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "EmailConfirmError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignInputEmailConfirmSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "emailConfirm",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CampaignInputEmailConfirmSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "emailConfirm",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c7e6e1ccf812c250d6e83870841e079a",
    "id": null,
    "metadata": {},
    "name": "CampaignInputEmailConfirmSaveMutation",
    "operationKind": "mutation",
    "text": "mutation CampaignInputEmailConfirmSaveMutation(\n  $input: EmailConfirmMutationInput!\n) {\n  emailConfirm(input: $input) {\n    __typename\n    ... on Influencer {\n      newEmail\n      email\n      id\n    }\n    ... on EmailConfirmError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b485da1255b468bd4e1b006863ff782d";

export default node;
